import { useQuery } from "@apollo/client";
import { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { CloseIcon, XclusiveIconLinear } from "src/components/Icons";
import LuxeFeaturesModal from "src/components/LuxeFeaturesModal";
import PaymentFlowModal from "src/components/PaymentFlowModal";
import XclusiveFeaturesModal from "src/components/XclusiveFeaturesModal";
import { GetEvent, GetLuxeDetails } from "src/graphql/queries";
import useAppStore from "src/store/utils";
import { DescribeLuxe, event } from "src/types/api";
import { TemplateType } from "../website/Templates";
import Template from "./Template";

const Templates = () => {
  const navigate = useNavigate();

  const { event } = useAppStore((state) => state);

  const [currency, setCurrency] = useState<string | undefined>("");
  const [discountedCost, setDiscountedCost] = useState<number | undefined>(0);
  const [undiscountedCost, setUnDiscountedCost] = useState<number | undefined>(
    0
  );

  const [isLuxeFeaturesOpen, setIsLuxeFeaturesOpen] = useState(false);
  const [isXclusiveFeaturesOpen, setIsXclusiveFeaturesOpen] = useState(false);

  const [openPaymentFlow, setOpenPaymentFlow] = useState(false);

  const [isLuxeEvent, setIsLuxeEvent] = useState(false);

  useQuery<DescribeLuxe>(GetLuxeDetails, {
    variables: { event_id: event?.uuid },
    fetchPolicy: "network-only",
    // fetchPolicy: "cache-and-network",
    onCompleted(response) {
      setCurrency(response.describeLuxe.currency);
      setDiscountedCost(response.describeLuxe.discounted_amount);
      setUnDiscountedCost(response.describeLuxe.undiscounted_amount);
    },
    onError(error) {
      if (error?.message !== "unauthenticated") {
        toast.error(
          <p className="toast">{error?.message ?? "An error occured"}</p>
        );
      } else {
        navigate("/clear");
      }
    },
  });

  useQuery<event>(GetEvent, {
    variables: {
      eventId: event?.id,
    },
    onCompleted(data) {
      setIsLuxeEvent(data.event?.luxe ?? false);
    },
  });

  const templates: TemplateType[] = [
    {
      id: "default",
      name: "Stellar",
      image: "/default-demo-image.png",
      // badge: "Luxe",
      // useCount: 0,
      // likes: 0,
      description: "A beautiful template for your wedding website",
      // previewCount: 0,
    },
    // {
    //   id: "eterna",
    //   name: "Eterna",
    //   image: "/eterna-demo-image.png",
    //   // badge: "Exclusive",
    //   // useCount: 2,
    //   // likes: 10,
    //   description: "A beautiful template for your wedding website",
    //   // previewCount: 0,
    // },
    {
      id: "lumen",
      name: "Lumen",
      image: "/lumen-demo-image.png",
      // badge: "Luxe",
      // useCount: 2,
      // likes: 5,
      description: "A beautiful template for your wedding website",
      // previewCount: 0,
    },
    {
      id: "lilac",
      name: "Lilac",
      image: "/lilac-demo-image.png",
      // badge: "Luxe",
      // useCount: 2,
      // likes: 5,
      description: "A beautiful template for your wedding website",
      // previewCount: 0,
    },
    {
      id: "blanc",
      name: "Blanc",
      image: "/blanc-demo-image.png",
      // badge: "Luxe",
      // useCount: 2,
      // likes: 5,
      description: "A beautiful template for your wedding website",
      // previewCount: 0,
    },
    {
      id: "funky",
      name: "Funky",
      image: "/funky-demo-image.png",
      // badge: "Luxe",
      // useCount: 2,
      // likes: 5,
      description: "A beautiful template for your wedding website",
      // previewCount: 0,
    },
    {
      id: "french",
      name: "French",
      image: "/french-demo-image.png",
      // badge: "Luxe",
      // useCount: 2,
      // likes: 5,
      description: "A beautiful template for your wedding website",
      // previewCount: 0,
    },
    {
      id: "fairy",
      name: "Fairy",
      image: "/fairy-demo-image.png",
      // badge: "Luxe",
      // useCount: 2,
      // likes: 5,
      description: "A beautiful template for your wedding website",
      // previewCount: 0,
    },
  ];

  return (
    <div className="">
      <div className="flex w-full justify-end pr-4 pt-4 md:mb-4">
        <div
          className="cursor-pointer"
          onClick={() => {
            navigate("/website");
          }}
        >
          <CloseIcon />
        </div>
      </div>
      <div className="p-8 md:px-16 md:py-12">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-xl font-semibold md:text-2xl">Templates</h2>
          <div className="flex gap-4">
            <XclusiveFeaturesModal
              isXclusiveFeaturesOpen={isXclusiveFeaturesOpen}
              setIsXclusiveFeaturesOpen={setIsXclusiveFeaturesOpen}
            />
            <LuxeFeaturesModal
              isLuxeFeaturesOpen={isLuxeFeaturesOpen}
              opened={isLuxeFeaturesOpen}
              setIsLuxeFeaturesOpen={setIsLuxeFeaturesOpen}
              currency={currency}
              discountedCost={discountedCost}
              undiscountedCost={undiscountedCost}
              setOpenPaymentFlow={setOpenPaymentFlow}
            />

            <PaymentFlowModal
              openPaymentFlow={openPaymentFlow}
              setOpenPaymentFlow={setOpenPaymentFlow}
            />
            <button
              className="hidden items-center gap-2 rounded-md border border-gray-400 px-4 py-2 text-sm transition duration-500 hover:scale-[1.02] hover:shadow-lg md:flex"
              onClick={() => setIsXclusiveFeaturesOpen(true)}
            >
              I want my own design{" "}
              <span>
                {" "}
                <XclusiveIconLinear />{" "}
              </span>
            </button>
            {/* <StyledButton
              variant="border-black"
              className="group flex cursor-pointer items-center gap-1 rounded-md border border-gray-400 px-4 py-2 text-sm"
            >
              5 <BlackLoveIcon size="small" />
            </StyledButton> */}
          </div>
        </div>

        <p className="mb-8 text-sm -tracking-[0.2px] text-[#5D5C5C]">
          Pick a unique look for your wedding website
        </p>

        {/* <div className="mb-8 flex gap-2 overflow-auto md:mb-12">
          <span className="cursor-pointer rounded-md border border-[#298576] px-2 py-1 text-xs uppercase text-[#298576] transition duration-500">
            Wedding
          </span>
          <span className="cursor-pointer rounded-md border border-gray-300 px-2 py-1 text-xs uppercase text-[#918E8E] transition duration-500 hover:border-[black] hover:text-[black]">
            Birthday
          </span>
          <span className="cursor-pointer rounded-md border border-gray-300 px-2 py-1 text-xs uppercase text-[#918E8E] transition duration-500 hover:border-[black] hover:text-[black]">
            Parties
          </span>
          <span className="cursor-pointer rounded-md border border-gray-300 px-2 py-1 text-xs uppercase text-[#918E8E] transition duration-500 hover:border-[black] hover:text-[black]">
            Others
          </span>
        </div> */}

        <div className="grid max-w-[1920px] grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 lg:grid-cols-3 lg:gap-4 xl:gap-10">
          {templates.map((template) => (
            <Template
              key={template.id}
              id={template.id}
              name={template.name}
              image={template.image}
              isLuxeEvent={isLuxeEvent}
              // badge={template.badge}
              setIsLuxeFeaturesOpen={setIsLuxeFeaturesOpen}
              setIsXclusiveFeaturesOpen={setIsXclusiveFeaturesOpen}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Templates;
